import { Component, input } from '@angular/core';
import { getCurrentBreakpoint } from '../../../helpers';

@Component({
  selector: 'app-company-logo',
  templateUrl: './company-logo.component.html',
  styleUrls: ['./company-logo.component.scss'],
  standalone: false,
})
export class CompanyLogoComponent {
  readonly imageSource = input<string>('https://i0.wp.com/panoptyc.com/wp-content/uploads/2025/10/Panoptyc-Logo-HiRes.jpg');

  public routeTo = input<string[]>([]);
  public showText = input<boolean>(true);

  public get shouldShowTitle() {
    return this.showText() && getCurrentBreakpoint() !== 'sm';
  }
}
